var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInbox48Line = function SvgIconInbox48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V14.6c0-2.92-2.38-5.3-5.3-5.3Zm-18.8 3.4h18.8c1.05 0 1.9.85 1.9 1.9v12.7h-6.61c-1.13 0-2.13.65-2.63 1.69a2.276 2.276 0 0 1-4.12 0c-.5-1.04-1.5-1.69-2.63-1.69H12.7V14.6c0-1.05.85-1.9 1.9-1.9Zm20.7 20.7a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9v-2.7h6.29c.99 1.83 2.92 3 5 3s4.02-1.17 5-3h6.29v2.7h.02Z",
    fill: "current"
  })));
};
export default SvgIconInbox48Line;